export const fundMask = [
  { title: "Icon", field: "fileLogo" },
  { title: "Tags", field: "tags" },
  { title: "Company name", field: "nameBrand" },
  { title: "Stage", field: "" },
  { title: "Year Founded", field: "createdAt" },
  { title: "Description", field: "descriptionShort" },
  { title: "HQ", field: "" },
  { title: "AUM", field: "committedCapitalTotal" },
];

export const assetManagerMask = [
  { title: "Icon", field: "image" },
  { title: "Tags", field: "tags" },
  { title: "Company name", field: "nameCompany" },
  { title: "Stage", field: "stage" },
  { title: "Year Founded", field: "year_founded" },
  { title: "Description", field: "description" },
  { title: "Fund Manager", field: "fund_manager" },
  { title: "AUM", field: "AUM" },
];

export const companyMask = [
  { title: "Icon", field: "fileLogo" },
  { title: "Tags", field: "tags" },
  { title: "Company name", field: "nameBrand" },
  { title: "HQ", field: "HQ" },
  { title: "Year Founded", field: "year_founded" },
  { title: "Description", field: "descriptionExpanded" },
  { title: "Deal Stage", field: "activeRound" },
  { title: "Total Raised", field: "totalRaised" },
];
